import {externalBaseApi, extractData} from "../../api/axiosConfig";


export const getAllProfiles = () =>
    externalBaseApi
        .get("/profile")
        .then(extractData);

export const addProfile = data =>
    externalBaseApi
        .post("/profile", data)
        .then(extractData);

export const editProfile = (profileId, data) =>
    externalBaseApi
        .put(`/profile/${profileId}`, data)
        .then(extractData);

export const deleteProfile = profileId =>
    externalBaseApi
        .delete(`/profile/${profileId}`)
        .then(extractData);

export const uploadProfile = profile =>
    externalBaseApi
        .post("/profile/upload", profile)
        .then(extractData);

export const getPaymentSystems = () =>
    externalBaseApi
        .get("/profile/paymentSystem")
        .then(extractData);

export const getPayStatuses = () =>
    externalBaseApi
        .get("/profile/payStatus")
        .then(extractData);

export const getStatuses = () =>
    externalBaseApi
        .get("/profile/status")
        .then(extractData);

export const profileSearch = request =>
    externalBaseApi
        .post("/profile/profileSearch", request)
        .then(extractData);


//
// import axios from "axios";
//
//
// const BASE_URL = import.meta.env.VITE_BACKEND_URL;
//
//
// export const getAllProfiles = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/profile`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const addProfile = abcd =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/profile`, abcd, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const editProfile = (selectorProfileId, data) =>
//     axios.put(`${BASE_URL}/ExternalData/api/contramatic/profile/${selectorProfileId}`, data, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
//
// //https://www.javatpoint.com/react-axios-delete-request-example except that it shows the wrong kinds of quotes - not backquotes
// export const deleteProfile = profileId =>
//     axios.delete(`${BASE_URL}/ExternalData/api/contramatic/profile/${profileId}`,{
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export   const uploadProfile = (profile) =>
//     axios.post(`${BASE_URL}/ExternalData/api/contramatic/profile/upload`,profile, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         .then(function (response) {
//             console.log(response);
//         })
//         .catch(function (error) {
//             if (error.response) {
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 console.log(error.request);
//             } else {
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const getPaymentSystems = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/profile/paymentSystem`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getPayStatuses = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/profile/payStatus`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
// export const getStatuses = () =>
//     axios.get(`${BASE_URL}/ExternalData/api/contramatic/profile/status`, {
//         headers: {
//             'Authorization': 'Bearer ' + localStorage.getItem('token')  // Add the token in Authorization header
//         }
//     })
//         //https://axios-http.com/docs/handling_errors
//         .catch(function (error) {
//             if (error.response) {
//                 // The request was made and the server responded with a status code
//                 // that falls out of the range of 2xx
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//                 // http.ClientRequest in node.js
//                 console.log(error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an Error
//                 console.log('Error', error.message);
//             }
//             console.log(error.config);
//         });
//
//
// export const profileSearch = (request) =>
//
//     axios.post(
//         `${BASE_URL}/ExternalData/api/contramatic/profile/profileSearch`,
//         request,
//         // CONFIG
//         {
//             headers: {
//                 Authorization:
//                     'Bearer ' + localStorage.getItem('token'),
//                 'Content-Type': 'application/json'
//             }
//         }
//     )
//
//         .catch(function (error) {
//
//             if (error.response) {
//
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//
//             } else if (error.request) {
//
//                 console.log(error.request);
//
//             } else {
//
//                 console.log('Error', error.message);
//
//             }
//
//             console.log(error.config);
//
//         });
